import { SEARCH_ACTIVE_TAB } from '../constants';

const DEFAULT_STATE = {
  activeTab: undefined,
};

export const search = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case SEARCH_ACTIVE_TAB:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
